import {Component, Input, OnInit} from '@angular/core';
import {animate, state, style, transition, trigger} from "@angular/animations";
import {EVENT_DETAILS, RACE_DETAILS} from "src/app/app-routing.module";
import {ActivatedRoute, Router} from "@angular/router";
import {AbstractComponent} from "@components";
import {
  ActionResultList,
  EventItem,
  EventItemType,
  EventRaceItem,
  EventsByMonth,
  ItemType, Lookups,
  Race,
  RacesByMonth
} from "@model";
import {EventRaceService} from "@services";
import {environment} from "@environment";

@Component({
  selector: 'app-user-profile-dashboard-body',
  templateUrl: './user-profile-dashboard-body.component.html',
  styleUrls: ['./user-profile-dashboard-body.component.scss'],
  animations: [
    trigger('fadeInAnimation', [
      state('in', style({opacity: 1})),
      transition(':enter', [
        style({opacity: 0}),
        animate(1600)
      ])
    ])]
})
export class UserProfileDashboardBodyComponent extends AbstractComponent implements OnInit{
  @Input({required:true}) languages: Lookups[] = [];
  @Input() favoriteItems: EventItem [] = [];
  @Input() countries: Lookups[] = [];
  protected readonly EventItemType = EventItemType;
  calendarType: EventItemType = EventItemType.MY_FAVORITE;

  months: (RacesByMonth[] | EventsByMonth[]) = []
  items: Race[] = [];
  findActive = true;
  typeOfRace: EventItemType = EventItemType.UPCOMING;
  itemType: ItemType | any;
  headerTitleKey: string = "";
  isLoggedIn: boolean = false;
  hasMore: boolean = false;
  page: number = 1;
  images: string[] = [1, 2, 3].map((n: number) => `${environment.assetsImagesPath}/assets/img/carousel/carousel${n}.jpg`);

  constructor(private router: Router, private eventRaceService: EventRaceService,
              private route: ActivatedRoute) {
    super();
  }

  ngOnInit(): void {
    this.subscribeToQueryParamsChange();
    this.subscribeToHasMoreItemsChange();
    this.subscribeToEventRaceItemsChange();
    this.subscribeToFavoritesChange();
  }

  setTypes(type: EventItemType): void {
    switch (type) {
      case EventItemType.FINISHED:
        this.findActive = false;
        this.itemType = ItemType.EVENT;
        this.headerTitleKey = 'landing.finished.races';
        break;
      case EventItemType.UPCOMING:
        this.findActive = true;
        this.itemType = ItemType.EVENT;
        this.headerTitleKey = 'landing.upcoming.races';
        break;
      case EventItemType.MY_FINISHED:
        this.findActive = false;
        this.itemType = ItemType.RACE;
        this.headerTitleKey = 'page.header.my.finished.races';
        break;
      case EventItemType.MY_REGISTERED:
        this.findActive = true;
        this.itemType = ItemType.RACE;
        this.headerTitleKey = 'page.header.registered.races';
        break;
      case EventItemType.MY_FAVORITE:
        this.findActive = true;
        this.itemType = ItemType.EVENT;
        this.headerTitleKey = 'page.header.favorites.races';
        break;
      default:
        break;
    }
  }

  initializeEventItems(): void {
    if (this.typeOfRace === EventItemType.MY_FAVORITE) {
      this.eventRaceService.fetchUserFavoritesEventRaces(true);
    } else {
      this.eventRaceService.findEventRacesPaged(this.itemType, this.typeOfRace, this.page, () => {
      }, () => {
      })
    }
  }

  subscribeToHasMoreItemsChange(): void {
    this.subscriptions.push(this.eventRaceService.hasMoreEventRace.subscribe((value: boolean) => {
      this.hasMore = value;
    }));
  }

  subscribeToEventRaceItemsChange(): void {
    this.subscriptions.push(this.eventRaceService.eventRaces.subscribe((value: ActionResultList<EventRaceItem[], number> | null) => {
      if (value != null && value.result != null && value.result.length > 0) {
        this.items = value.result;
        this.page++;
      } else {
        this.items = [];
      }
    }))
  }

  subscribeToFavoritesChange(): void {
    this.subscriptions.push(this.eventRaceService.favoriteEventRaces.subscribe((value: ActionResultList<EventRaceItem[], number> | null) => {
      if (value && value.result?.length !== undefined) {
        this.favoriteItems = value.result;
      } else {
        this.favoriteItems = [];
      }
    }))
  }

  subscribeToQueryParamsChange(): void {
    this.subscriptions.push(this.route.queryParams.subscribe(p => {
      this.typeOfRace = p['typeOfRace'] as EventItemType;
      this.setTypes(this.typeOfRace);
      this.hasMore = false;
      this.page = 1;
      // this.eventRaceService.emptyEventRaces();
      this.initializeEventItems();
    }));
  }

  getEventItem(item: EventRaceItem): EventRaceItem {
    return item;
  }

  getRaceItem(item: Race): Race {
    return item;
  }

  isTypeEvent() {
    return this.itemType === ItemType.EVENT;
  }

  isEventItem(item: Race): item is EventRaceItem {
    // if (this.itemType === ItemType.EVENT) {
    //   return this.getEventIem(item).type === "E" ? true : false;
    // }
    return false;
  }

  showFavorites(): boolean {
    return this.typeOfRace === EventItemType.MY_FAVORITE
  }
  trackByFn(index: number, item: EventItem) {
    return item.id;
  }

  goToEventDetailsFavoritesPage(event: EventRaceItem): void {
    if (event.type === "E") {
      this.router.navigate([EVENT_DETAILS], {
        relativeTo: this.route,
        queryParams: {eventId: event.id, typeOfRace: EventItemType.MY_FAVORITE}
      });
    }
    if (event.type === "R") this.router.navigate([RACE_DETAILS], {
      relativeTo: this.route,
      queryParams: {raceId: event.id, typeOfRace: EventItemType.MY_FAVORITE},
    });

  }

  goToEventDetailsPage(event: EventRaceItem): void {
    this.router.navigate([EVENT_DETAILS], {queryParams: {eventId: event.id}});
  }

  loadMore(): void {
    this.eventRaceService.findEventRacesPaged(this.itemType, this.typeOfRace, this.page, () => {
    }, () => {
    })
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.eventRaceService.emptyEventRaces();
  }
}
